export default "__VITE_ASSET__BooRbbsY__"